import { Phone, MapPin, ExternalLink } from "lucide-react";
import { PHONE, PHONE_LINK, ADDRESS, MAPS_LINK, MENU_LINK } from "../data/menu";

export const Footer = ({ onLegal }) => (
  <footer id="kontakt" data-testid="footer" className="relative z-10 overflow-hidden bg-[#1A1C19] pt-20 text-[#F9F8F6]">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.28em] text-[#78825B]">Kontakt</p>
          <a
            href={PHONE_LINK}
            data-testid="footer-call-button"
            className="font-display block text-4xl font-light tracking-tight transition-colors duration-300 hover:text-[#4B7F94] sm:text-5xl"
          >
            {PHONE}
          </a>
          <p className="mt-3 text-sm text-[#F9F8F6]/60">Anrufen, bestellen, abholen — in ca. 10 Minuten fertig.</p>
        </div>
        <div className="md:col-span-3 md:col-start-7">
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.28em] text-[#78825B]">Adresse</p>
          <p className="flex items-start gap-3 text-sm leading-relaxed text-[#F9F8F6]/85">
            <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" />
            {ADDRESS}
          </p>
          <a
            href={MAPS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-directions-link"
            className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#F9F8F6]/70 transition-colors duration-300 hover:text-[#4B7F94]"
          >
            Route planen
            <ExternalLink size={13} strokeWidth={1.5} />
          </a>
        </div>
        <div className="md:col-span-2 md:col-start-11">
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.28em] text-[#78825B]">Bestellen</p>
          <a
            href={MENU_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-menu-link"
            className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#F9F8F6]/70 transition-colors duration-300 hover:text-[#4B7F94]"
          >
            m.tsolias.de
            <ExternalLink size={13} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p
        aria-hidden="true"
        className="font-display select-none whitespace-nowrap text-center text-[22vw] font-light leading-[0.85] tracking-tight text-[#F9F8F6]/[0.06]"
      >
        TSOLIAS
      </p>
    </div>
    <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-6 text-xs text-[#F9F8F6]/40 md:px-10">
      <p>© 2026 Imbiss Tsolias Restaurant · Spandauer Straße 1, 57072 Siegen</p>
      <div className="flex flex-wrap items-center gap-6">
        <a
          href="mailto:petridisdimi@gmail.com"
          data-testid="footer-email-link"
          className="transition-colors duration-300 hover:text-[#F9F8F6]"
        >
          petridisdimi@gmail.com
        </a>
        <button
          onClick={() => onLegal("impressum")}
          data-testid="footer-impressum-link"
          className="font-semibold uppercase tracking-[0.15em] transition-colors duration-300 hover:text-[#F9F8F6]"
        >
          Impressum
        </button>
        <button
          onClick={() => onLegal("datenschutz")}
          data-testid="footer-datenschutz-link"
          className="font-semibold uppercase tracking-[0.15em] transition-colors duration-300 hover:text-[#F9F8F6]"
        >
          Datenschutz
        </button>
      </div>
    </div>
  </footer>
);
